'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { rem } from '@s7/styles';
import { Popover } from '../Popover/Popover.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var InputPopoverDropdown = function(props) {
    var children = props.children, _props_as = props.as, as = _props_as === void 0 ? "div" : _props_as, _props_maxHeight = props.maxHeight, maxHeight = _props_maxHeight === void 0 ? 220 : _props_maxHeight, id = props.id, innerRef = props.innerRef, others = _object_without_properties_loose(props, [
        "children",
        "as",
        "maxHeight",
        "id",
        "innerRef"
    ]);
    return /*#__PURE__*/ jsx(Popover.Dropdown, _extends({
        onMouseDown: function(event) {
            return event.preventDefault();
        }
    }, others, {
        children: /*#__PURE__*/ jsx(Box, {
            ref: innerRef,
            "aria-labelledby": "" + id + "-label",
            as: as,
            id: "" + id + "-items",
            role: "listbox",
            style: {
                maxHeight: rem(maxHeight),
                display: "inline"
            },
            tabIndex: -1,
            "data-combobox-popover": true,
            onMouseDown: function(event) {
                return event.preventDefault();
            },
            children: children
        })
    }));
};
var InputPopover = function(props) {
    var _props_transitionProps = props.transitionProps, transitionProps = _props_transitionProps === void 0 ? {
        transition: "fade",
        duration: 0
    } : _props_transitionProps, dropdownPosition = props.dropdownPosition, children = props.children, others = _object_without_properties_loose(props, [
        "transitionProps",
        "dropdownPosition",
        "children"
    ]);
    return /*#__PURE__*/ jsx(Popover, _extends({
        transitionProps: transitionProps,
        width: "target"
    }, others, {
        middlewares: {
            flip: dropdownPosition === "flip",
            shift: false
        },
        position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
        withRoles: false,
        children: children
    }));
};
InputPopover.Target = Popover.Target;
InputPopover.Dropdown = InputPopoverDropdown;

export { InputPopover, InputPopover as default };
